// game-tile.service.ts
import { Injectable } from '@angular/core';
import { UserSessionService } from '../user-session/user-session.service';
import { GameHubControllerService } from '../gameHub/game-hub-controller';
import { Navigator } from '../../components/menu/navigator';
import { AppLinksService } from '../applinks/app-links.service';
import { WebcontentService } from '../webcontent/webcontent.service';
import { ConfigService } from '..//config/config.service';
import { GamesService } from '..//lobby/games.service';
import { LobbyService } from '..//lobby/lobby.service';

@Injectable({
  providedIn: 'root',
})
export class GameTileService {
  public isAuthenticated: boolean = false;
  public isTop: boolean;

  constructor(
    private userSessionService: UserSessionService,
    private gameHubControllerService: GameHubControllerService,
    private navigator: Navigator,
    private appLinksService: AppLinksService,
    private webcontentService: WebcontentService,
    private configService: ConfigService,
    private gamesService: GamesService,
    private lobbyService: LobbyService,
  ) {
    this.verifyAuth();
    this.isTop = this.configService.getConfig().FEATURE_JACKPOT_POSITION_TOP === '1';
  }

  verifyAuth() {
    this.userSessionService.getAuthenticationStatus().subscribe((res) => {
      this.isAuthenticated = res;
    });
  }

  onTileButton(gameData: any): any {
    if (gameData.externalLink?.url) {
      this.launchExternalLink(gameData);
      return;
    }
    if (!this.isAuthenticated) {
      this.lobbyService.setWaitingGameData(gameData);
      return this.onLogin(gameData);
    }
    this.gameHubControllerService.launchCasinoGame(gameData);
  }

  launchExternalLink(data) {
    const externalLink = data.externalLink;
    if (externalLink?.url) {
      const url = externalLink.url;
      if (externalLink.isExternalUrl) {
        this.appLinksService.openExternalPage(url);
      } else {
        if (externalLink.label === 'action_links') {
          if (this.isAuthenticated) {
            this.navigator.navigateTo(url, { multipleModals: true });
          } else {
            this.lobbyService.setWaitingDialogPage(url);
            this.navigator.navigateTo('LoginComponent');
          }
        } else {
          this.webcontentService.updateExternalLink(url);
          this.navigator.toTab('c', false, url);
        }
      }
    }
  }

  onLogin(gameData: any) {
    if (gameData?.super_type === 'LIVE_DEALER') {
      localStorage.setItem('skipActiveBonusCheck', 'true');
    }
    this.navigator.navigateTo('LoginComponent');
  }

  onInfo(gamedata: any) {
    this.navigator.navigateTo('GameDetailsComponent', { multipleModals: true }, { gamedata });
  }

  isFavourite(game_id: string): boolean {
    if (!this.isAuthenticated) return false;
    return this.gamesService.isFavourite(game_id);
  }

  makeFavourite(gamedata: any) {
    this.gamesService.addFavouritesAndRecreate(gamedata);
  }

  makeUnFavourite(game_id: string, currentKeyword = "") {
    this.gamesService.removeFavouritesAndRecreate(game_id, currentKeyword);
  }
}
